import React, { useContext } from 'react';
import { CircleHelp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { LanguageProviderContext } from '@/providers/LanguageProvider';
import { formatWeightBreakdown } from '@/utils/weightPricing';

const EXAMPLES_KG = [1.5, 10.07, 0.25];

const WeightInputHelp: React.FC = () => {
  const { translator } = useContext(LanguageProviderContext);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-4 shrink-0 rounded-full p-0 text-muted-foreground hover:text-foreground"
          aria-label={translator('ProductsCatalog.weightHelpAria')}
        >
          <CircleHelp className="size-3.5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent side="top" collisionPadding={12} className="w-64 space-y-2 p-3 text-sm">
        <p className="font-medium">{translator('ProductsCatalog.weightHelpTitle')}</p>
        <p className="text-muted-foreground">{translator('ProductsCatalog.weightHelpKg')}</p>
        <ul className="space-y-1 rounded-md bg-muted/50 p-2 tabular-nums">
          {EXAMPLES_KG.map((kg) => (
            <li key={kg} className="flex justify-between gap-3">
              <span className="font-mono">{kg} kg</span>
              <span className="font-medium">{formatWeightBreakdown(kg)}</span>
            </li>
          ))}
        </ul>
        <p className="text-xs text-muted-foreground">
          {translator('ProductsCatalog.weightHelpFooter')}
        </p>
      </PopoverContent>
    </Popover>
  );
};

export default WeightInputHelp;
